import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaDownload, FaGithub, FaInstagram, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t, i18n } = useTranslation();

  const cvLink = i18n.language === 'en' ? '/pdfs/EN_ResumeMarianoVentura.pdf' : '/pdfs/ES_ResumeMarianoVentura.pdf';
  const isEn = i18n.language === 'en';
  const title = isEn ? 'Mariano Ventura | Full Stack Developer' : 'Mariano Ventura | Desarrollador Full Stack';
  const desc = isEn
    ? 'Portfolio profesional de Mariano Ventura. Desarrollador Full Stack con experiencia en React, .NET, React Native, AWS y más.'
    : 'Professional portfolio of Mariano Ventura. Full Stack Developer with experience in React, .NET, React Native, AWS and more.';

  return (
    <section id="home" className="hero">
      <Helmet>
        <html lang={i18n.language} />
        <title>{title}</title>
        <meta name="description" content={desc} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:locale" content={isEn ? 'en_US' : 'es_ES'} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <link rel="alternate" hreflang="es" href={isEn ? 'https://marianoventura.dev' : 'https://marianoventura.dev'} />
        <link rel="alternate" hreflang="en" href={isEn ? 'https://marianoventura.dev/en' : 'https://marianoventura.dev/en'} />
      </Helmet>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('hero.title')}<br /><span>Mariano Ventura</span>
          </h1>
          <h2 className="hero-subtitle">{t('hero.subtitle')}</h2>
          <p className="hero-description">
            {t('hero.description')}
          </p>
          
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary">
              <FaEnvelope /> {t('hero.contactBtn')}
            </a>
            <a href={cvLink} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
              <FaDownload /> {t('hero.downloadBtn')}
            </a>
          </div>
          
          <div className="hero-social">
            <a href="https://github.com/mvc2511" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub aria-hidden="true" />
            </a>
            <a href="https://www.linkedin.com/in/mvc251/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin aria-hidden="true" />
            </a>
            <a href="https://www.instagram.com/bit.mvc/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;